import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  cardContainerStyle: theme => ({
    marginTop: 16,
    marginBottom: 20,
    paddingVertical: 16,
    paddingHorizontal: 16,
    marginHorizontal: 2,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    elevation: 2,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
  }),
  headerTitleViewStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    overflow: 'hidden',
    flex: 1,
  },
  statusStyle: colors => ({
    fontWeight: 'bold',
    fontFamily: Fonts.type.VFFont,
    fontSize: 16.6,
    lineHeight: 23,
    color: colors.myPlanPrimaryCardStatus,
    marginTop: -2,
  }),
  renewalDateStyle: theme => ({
    fontSize: 14,
    lineHeight: 23,
    color: theme.colors.textColorTwo,
  }),
  titleStyle: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    lineHeight: 31.3,
    color: theme.colors.headerTitleColor,
    marginTop: 16.7,
  }),
  divider: theme => ({
    marginVertical: 16,
    borderBottomColor: theme.colors.divider,
    borderBottomWidth: 1,
  }),
  contentDivider: theme => ({
    borderBottomColor: theme.colors.divider,
    borderBottomWidth: 1,
  }),
  usageValuesView: {
    paddingBottom: 10,
  },
  usageItemsContainerStyle: {
    marginTop: 5,
    marginBottom: 8.8,
  },
  priceDetailsViewStyle: {
    flexDirection: 'row',
    marginTop: 20,
    marginBottom: 16,
  },
  priceValueViewStyle: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    flex: 1,
    lineHeight: 48,
  },
  priceValueAmountStyle: {
    fontSize: 40,
    fontFamily: Fonts.type.VodafoneLt,
  },
  priceValueUnitStyle: {
    fontSize: 34,
    fontFamily: Fonts.type.VodafoneLt,
    paddingBottom: 3,
  },
  priceLabelStyle: {
    fontSize: 16.6,
    fontWeight: 'bold',
    flex: 1,
  },
  upgradeButtonStyle: {
    marginVertical: 16,
  },
  showMoreText: theme => ({
    color: theme.colors.showMoreColor,
    fontFamily: Fonts.type.VFFont,
    fontSize: 16.7,
    textAlign: 'center',
  }),
  showMoreContainer: {
    flexGrow: 1,
    justifyContent: 'center',
    marginHorizontal: 15,
    marginTop: 12.5,
    marginBottom: 12.5,
  },
});
